<template>
  <el-dropdown
    v-if="hasMultipleDashboards"
    class="switch-dashboard-dropdown"
    placement="left-start"
    trigger="click"
    :popper-options="popperOptions"
    popper-class="th-dropdown-menu"
    data-testid="mms-dashboard-switcher"
  >
    <div
      class="switch-dashboard-trigger"
      data-testid="mms-dashboard-switcher-trigger"
      @click.stop
    >
      {{ $t('nav.main.items.switch_dashboard.title') }}
    </div>
    <template #dropdown>
      <el-dropdown-menu
        class="mms-switcher-menu"
        data-testid="mms-dashboard-switcher-menu"
      >
        <el-dropdown-item
          v-for="dashboard in connectedDashboards"
          :key="dashboard.unzerId"
          data-testid="mms-dashboard-switcher-item"
          @click="onSelect(dashboard)"
        >
          <div class="dashboard-item">
            <span
              class="dashboard-name"
              :class="{ 'is-active': dashboard.unzerId === activeUnzerId }"
              data-testid="mms-dashboard-switcher-name"
            >
              {{ dashboard.name }}
            </span>
            <el-icon
              v-if="dashboard.unzerId === activeUnzerId"
              class="dashboard-check"
              data-testid="mms-dashboard-switcher-active"
            >
              <check-icon />
            </el-icon>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useConnectedDashboardsStore } from '@shared/store/connected-dashboards'
import { useAuthStore } from '@shared/store/auth'
import { getDefaultLandingPath } from '@uz/router/uz-router'
import { CheckIcon } from '@shared/assets/icons'

export default {
  components: {
    CheckIcon
  },
  setup() {
    const store = useConnectedDashboardsStore()
    const { connectedDashboards, activeUnzerId, hasMultipleDashboards } =
      storeToRefs(store)
    return { store, connectedDashboards, activeUnzerId, hasMultipleDashboards }
  },
  data() {
    return {
      popperOptions: {
        modifiers: [
          { name: 'flip', enabled: false },
          {
            name: 'offset',
            options: { offset: [0, 24] }
          }
        ]
      }
    }
  },
  methods: {
    async onSelect(dashboard) {
      const switched = await this.store.switchDashboard(dashboard.unzerId)
      if (!switched) return

      const router = this.$router
      if (!router) return

      const authStore = useAuthStore()
      await authStore.waitThInitializated()
      await authStore.waitForMeData()

      await router.replace(getDefaultLandingPath()).catch(() => {})

      await this.store.completeDashboardSwitch()
    }
  }
}
</script>

<style scoped>
.switch-dashboard-dropdown {
  display: flex;
  width: 100%;
  color: inherit;
}

.switch-dashboard-trigger {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 28px;
  cursor: pointer;
  outline: none;
}

.dashboard-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
}

.dashboard-name.is-active {
  color: var(--el-color-primary);
}

.dashboard-check {
  color: var(--el-color-primary);
}

.mms-switcher-menu {
  padding-top: 0;
  padding-bottom: 0;
}

.mms-switcher-menu :deep(.el-dropdown-menu__item) {
  height: 40px;
}

.mms-switcher-menu :deep(.el-dropdown-menu__item:not(:first-child)) {
  border-top: 1px solid var(--border-color);
}
</style>
